import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Switch,
  CircularProgress,
  Alert
} from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';

const NotificationPreferences = ({ userId, supabase }) => {
  const [enabled, setEnabled] = useState(true);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!userId) return;
    const load = async () => {
      setLoading(true);
      const { data } = await supabase
        .from('notification_preferences')
        .select('email_enabled')
        .eq('user_id', userId)
        .maybeSingle();
      setEnabled(data ? data.email_enabled : true);
      setLoading(false);
    };
    load();
  }, [userId, supabase]);

  const handleToggle = async (e) => {
    const newVal = e.target.checked;
    setEnabled(newVal);
    setSaving(true);
    setError('');
    const { error: err } = await supabase
      .from('notification_preferences')
      .upsert(
        { user_id: userId, email_enabled: newVal, updated_at: new Date().toISOString() },
        { onConflict: 'user_id' }
      );
    setSaving(false);
    if (err) {
      setError('Nie udało się zapisać ustawień.');
      setEnabled(!newVal);
    }
  };

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
        <NotificationsIcon sx={{ color: '#D2691E', fontSize: 18 }} />
        <Typography sx={{ fontWeight: 600, fontSize: '14px', color: '#374151' }}>
          Powiadomienia email
        </Typography>
      </Box>

      {loading ? (
        <CircularProgress size={20} sx={{ color: '#D2691E' }} />
      ) : (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Box>
            <Typography sx={{ fontSize: '14px', fontWeight: 500, color: '#374151' }}>
              {enabled ? 'Włączone' : 'Wyłączone'}
            </Typography>
            <Typography sx={{ fontSize: '12px', color: '#6b7280' }}>
              {enabled
                ? 'Otrzymasz email gdy ktoś napisze do Ciebie (raz dziennie)'
                : 'Nie będziesz otrzymywać powiadomień email'}
            </Typography>
          </Box>
          <Switch
            checked={enabled}
            onChange={handleToggle}
            disabled={saving}
            sx={{
              ml: 2,
              flexShrink: 0,
              '& .MuiSwitch-thumb': { backgroundColor: '#fff' },
              '& .MuiSwitch-track': { backgroundColor: '#ccc', opacity: 1 },
              '& .MuiSwitch-switchBase.Mui-checked .MuiSwitch-thumb': { backgroundColor: '#fff' },
              '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                backgroundColor: '#4ade80',
                opacity: 1
              }
            }}
          />
        </Box>
      )}

      {error && (
        <Alert severity="error" sx={{ mt: 1, py: 0, fontSize: '13px' }}>
          {error}
        </Alert>
      )}

      <Typography sx={{ fontSize: '11px', color: '#9ca3af', mt: 0.5 }}>
        Wyraziłeś zgodę na otrzymywanie powiadomień email w naszej{' '}
        <a href="/polityka-prywatnosci" target="_blank" rel="noopener noreferrer"
           style={{ color: '#9ca3af' }}>
          polityce prywatności
        </a>{' '}
        podczas rejestracji.
      </Typography>
    </Box>
  );
};

export default NotificationPreferences;
